import { useEffect, useState } from "react";
import { Alert, Form, FormGroup, Input, Modal, Button } from "reactstrap";
import AppSpinner from "../../elements/AppSpinner";

const initialValues = {
  id: null,
  Name: "",
  Description: "",
};

// Modal component for creating new Templates
const EditTemplateInfoModal = ({
  open,
  toggle,
  onUpdate,
  submitting,
  error,
  data = null,
}) => {
  const [values, setValues] = useState(initialValues);

  useEffect(() => {
    if (data) {
      const { id, Name, Description } = data;
      setValues({ id, Name, Description });
    }
  }, [data]);

  const update = async (e) => {
    e.preventDefault();

    onUpdate(values, setValues, initialValues);
  };

  const closeModal = () => {
    if (!data) setValues(initialValues);
    toggle();
  };

  return (
    <Modal className="modal-dialog-centered" isOpen={open} toggle={toggle}>
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">
          {data ? `Edit ${data?.Name}` : "Create New Template"}
        </h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={toggle}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <Form onSubmit={update}>
        <div className="modal-body">
          <FormGroup>
            <h5>Name</h5>
            <Input
              placeholder="Name"
              value={values.Name}
              onChange={(e) =>
                setValues((prev) => ({ ...prev, Name: e.target.value }))
              }
            />
          </FormGroup>
          <FormGroup>
            <h5>Description</h5>
            <Input
              placeholder="Description"
              type="textarea"
              required={false}
              value={values.Description}
              onChange={(e) =>
                setValues((prev) => ({ ...prev, Description: e.target.value }))
              }
            />
          </FormGroup>
          {error && (
            <Alert color="warning" className="mt-3 mb-0">
              {error}
            </Alert>
          )}
        </div>
        <div className="modal-footer">
          <Button
            color="secondary"
            data-dismiss="modal"
            type="button"
            onClick={() => closeModal()}
          >
            Close
          </Button>
          <Button
            color="primary"
            type="submit"
            disabled={submitting || !values.Name}
          >
            {submitting ? (
              <AppSpinner color="white" />
            ) : data ? (
              "Update"
            ) : (
              "Create"
            )}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default EditTemplateInfoModal;
